import _extends from "@babel/runtime/helpers/extends";
import React from "react";
var CivicHRLogo = function CivicHRLogo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#007ebc",
    d: "M406.07 4.26a2.93 2.93 0 0 1 2.83-2.83h13.84a2.83 2.83 0 0 1 2.83 2.83v39.43h48.5V4.26a2.83 2.83 0 0 1 2.83-2.83h13.69a2.93 2.93 0 0 1 2.83 2.83v98.5a2.93 2.93 0 0 1-2.83 2.83h-13.64a2.83 2.83 0 0 1-2.83-2.83V61.7h-48.5v41.06a2.83 2.83 0 0 1-2.83 2.83h-13.84a2.93 2.93 0 0 1-2.83-2.83ZM511.65 4.26a2.83 2.83 0 0 1 2.83-2.83h42.55a32.23 32.23 0 0 1 32.44 32c0 13.69-9.08 24.85-22 30.06l20.38 37.79a2.82 2.82 0 0 1-2.53 4.32h-15.64a2.54 2.54 0 0 1-2.38-1.34l-19.79-39.43h-16.56v37.94a2.93 2.93 0 0 1-2.82 2.83h-13.65a2.83 2.83 0 0 1-2.83-2.83ZM555.4 48.9c7.88 0 14.73-6.85 14.73-15.18 0-7.88-6.85-14.43-14.73-14.43h-24.26V48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383938",
    d: "M53.72 0c15 0 25.89 4.77 36 13.84a2.77 2.77 0 0 1 .15 4.17l-9.07 9.37a2.38 2.38 0 0 1-3.72 0 35.23 35.23 0 0 0-22.92-8.81c-19.04 0-33.21 16-33.21 34.7s14.29 34.37 33.33 34.37c8.93 0 16.52-3.42 22.77-8.48a2.75 2.75 0 0 1 3.72 0l9.22 9.52a2.84 2.84 0 0 1-.15 4 51.05 51.05 0 0 1-36.15 14.44 53.57 53.57 0 1 1 0-107.14ZM108.71 4.32a2.93 2.93 0 0 1 2.82-2.83h13.84a2.93 2.93 0 0 1 2.83 2.83v98.5a2.93 2.93 0 0 1-2.83 2.83h-13.84a2.93 2.93 0 0 1-2.82-2.83ZM143.95 5.36a2.63 2.63 0 0 1 2.53-3.87h15.17a2.74 2.74 0 0 1 2.53 1.64l28.57 64h1l28.57-64a2.75 2.75 0 0 1 2.53-1.64h15.18a2.63 2.63 0 0 1 2.53 3.87L196.44 105.5a2.67 2.67 0 0 1-2.53 1.64h-1.49a2.67 2.67 0 0 1-2.52-1.64ZM258.55 4.32a2.93 2.93 0 0 1 2.83-2.83h13.84a2.93 2.93 0 0 1 2.82 2.83v98.5a2.93 2.93 0 0 1-2.82 2.83h-13.84a2.93 2.93 0 0 1-2.83-2.83ZM350.62 0c15 0 25.89 4.77 36 13.84a2.77 2.77 0 0 1 .15 4.17l-9.08 9.37a2.38 2.38 0 0 1-3.72 0 35.23 35.23 0 0 0-22.9-8.81c-19 0-33.18 15.92-33.18 34.67s14.28 34.37 33.33 34.37c8.92 0 16.51-3.42 22.76-8.48a2.75 2.75 0 0 1 3.72 0l9.23 9.52a2.84 2.84 0 0 1-.15 4 51.09 51.09 0 0 1-36.16 14.44 53.57 53.57 0 1 1 0-107.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007ebc",
    d: "M598.29 2.96a5.6 5.6 0 1 0 5.66 5.61 5.61 5.61 0 0 0-5.66-5.61Zm0 10a4.38 4.38 0 1 1 4.38-4.38 4.39 4.39 0 0 1-4.38 4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007ebc",
    d: "M600.14 7.9a1.36 1.36 0 0 0-1.37-1.39h-1.73a.21.21 0 0 0-.21.22v3.66a.2.2 0 0 0 .21.21h.55a.21.21 0 0 0 .21-.21V9.2h.58l.49 1.25a.23.23 0 0 0 .2.15h.6a.2.2 0 0 0 .19-.3l-.51-1.16a1.29 1.29 0 0 0 .79-1.24Zm-1.49.47h-.89v-.92h.89a.44.44 0 0 1 .46.46.45.45 0 0 1-.46.46Z"
  }));
};
CivicHRLogo.defaultProps = {
  'aria-labelledby': "cp-LogoCivicHR-title",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 603.89 107.13"
};
var CivicHRLogoCircle = function CivicHRLogoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".civic-hr-circle-logo", `{`, "fill:#fff", `}`)), /*#__PURE__*/React.createElement("circle", {
    cx: "203.52",
    cy: "203.52",
    r: "203.52",
    style: {
      fill: "#007ebc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "civic-hr-circle-logo",
    d: "M188.11 152.03h-41a51.7 51.7 0 1 0 0 103.39h41a4.93 4.93 0 0 0 4.92-4.87v-30a4.92 4.92 0 0 0-4.65-4.84h-41.31a12 12 0 1 1 0-24h41.2a4.92 4.92 0 0 0 4.7-4.85v-30a4.93 4.93 0 0 0-4.86-4.83ZM258.73 152.03h-40.65a4.92 4.92 0 0 0-4.85 4.63v30.44a4.92 4.92 0 0 0 4.82 4.63h40.68a12 12 0 0 1 0 24h-40.59a4.92 4.92 0 0 0-4.91 4.63v58.56a4.92 4.92 0 0 0 4.77 4.63h6.88a3.25 3.25 0 0 0 2.64-1.12l25.81-27h5.39a51.7 51.7 0 0 0 0-103.39Z"
  }));
};
CivicHRLogoCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 407.03 407.03"
};
import { useStyles } from "../styles";
import classNames from "classnames";
const CivicHRLogoWhite = ({
  className,
  ...otherProps
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(CivicHRLogo, _extends({
    className: classNames(className, classes.root)
  }, otherProps));
};
export default CivicHRLogo;
export { CivicHRLogoWhite, CivicHRLogoCircle };